/**
 * AlphaX Tuning Simulator - Utilities & Math
 */

class Interpolation {
    static interpolate1D(x, xValues, yValues, decayOverMax = false) {
        if (x <= xValues[0]) return yValues[0];
        
        if (x >= xValues[xValues.length - 1]) {
            let val = yValues[yValues.length - 1];
            if (decayOverMax) {
                const overRev = x - xValues[xValues.length - 1];
                const decay = Math.max(0, 1 - (overRev / 1000));
                return val * decay;
            }
            return val;
        }
        
        for (let i = 0; i < xValues.length - 1; i++) {
            if (x >= xValues[i] && x <= xValues[i + 1]) {
                const t = (x - xValues[i]) / (xValues[i + 1] - xValues[i]);
                return yValues[i] + t * (yValues[i + 1] - yValues[i]);
            }
        }
        return 0;
    }

    static interpolate2D(x, y, xAxis, yAxis, table) {
        let xVal = Math.max(xAxis[0], Math.min(x, xAxis[xAxis.length - 1]));
        let yVal = Math.max(yAxis[0], Math.min(y, yAxis[yAxis.length - 1]));
        let x0 = 0, x1 = 0, y0 = 0, y1 = 0;
        for (let i = 0; i < xAxis.length - 1; i++) { if (xVal >= xAxis[i] && xVal <= xAxis[i + 1]) { x0 = i; x1 = i + 1; break; } }
        for (let i = 0; i < yAxis.length - 1; i++) { if (yVal >= yAxis[i] && yVal <= yAxis[i + 1]) { y0 = i; y1 = i + 1; break; } }

        const q11 = table[y0][x0], q21 = table[y0][x1], q12 = table[y1][x0], q22 = table[y1][x1];
        const tx = (x1 === x0) ? 0 : (xVal - xAxis[x0]) / (xAxis[x1] - xAxis[x0]);
        const ty = (y1 === y0) ? 0 : (yVal - yAxis[y0]) / (yAxis[y1] - yAxis[y0]);
        const r1 = q11 * (1 - tx) + q21 * tx;
        const r2 = q12 * (1 - tx) + q22 * tx;
        return r1 * (1 - ty) + r2 * ty;
    }
}
